import Advertisers from './containers/AdvertisersContainer';

export default Advertisers;
